import { OptionFavorite } from './OptionFavorite';

export default OptionFavorite;
